function isWhiteSpace(node) {
    if (!node || typeof node === 'string' && node.match(/^\s*$/) !== null) {
        return true;
    }

    if (Object.prototype.hasOwnProperty.call(node, 'nodeType') && ['hr', 'embedded-entry-inline', 'embedded-asset-block'].includes(node.nodeType)) {
        return false;
    }

    if (Object.prototype.hasOwnProperty.call(node, 'content') && node.content.length) {
        return node.content.every(innerNode => isWhiteSpace(innerNode));
    }

    if (Object.prototype.hasOwnProperty.call(node, 'value') && node.nodeType === 'text') {
        return node.value.match(/^\s*$/) !== null;
    }

    return false;
}

export default isWhiteSpace;
